module.exports = __webpack_public_path__ + "img/hr-brown-fluff-00.b73efcac.png";